import { useGetSwimmersDiaryQuery } from "@/queries/useGetSwimmersDiaryQuery";
import { useGetClientQuery } from "@/queries/useGetClientQuery";
import { useMemo } from "react";

export const useSwimmersDiary = () => {
  const { data: clientData, isPending: isClientPending } = useGetClientQuery();

  const user_id = useMemo(() => {
    if (clientData) return `${clientData.id}`;
    return "";
  }, [clientData]);

  const userName = useMemo(() => {
    if (clientData) return `${clientData.last_name} ${clientData.name} ${clientData.second_name}`;
    return "";
  }, [clientData]);

  const { data: swimmersDiaryData, isLoading } = useGetSwimmersDiaryQuery(
    clientData,
    isClientPending,
    userName,
    user_id
  );

  if (isLoading) {
    return { swimmersDiaryData: [], isLoading };
  }

  return { swimmersDiaryData };
};
